import { useState } from 'react';

const useApiResponseState = () => {
  const [apiResponseMessage, setApiResponseMessage] = useState(null);
  const [forceCloseMessage, setForceCloseMessage] = useState(null);
  const [allowForceClose, setAllowForceClose] = useState(false);
  const [isForceCloseSuccessful, setIsForceCloseSuccessful] = useState(false);

  return {
    apiResponseMessage,
    setApiResponseMessage,
    forceCloseMessage,
    setForceCloseMessage,
    allowForceClose,
    setAllowForceClose,
    isForceCloseSuccessful,
    setIsForceCloseSuccessful,
  };
};

export default useApiResponseState;
